import React, { FC, memo, useEffect, useRef } from 'react';
import s from './index.module.scss';
import locales from '../../../content.json';
import { getDay } from '../../../utils/scripts/getDay';
import { getCurrencySymbol } from '../../../utils/scripts/currency';

type Link = {
  title?: string;
  link?: string;
};

type Props = {
  links?: Link[];
  period?: string;
  price?: string;
  product?: any;
};

const DisclamerNoTrial: FC<Props> = props => {
  const { links, period = '1 month', price, product } = props;
  const itemRef = useRef(null);
  const currency = getCurrencySymbol();

  if (!product) return;

  const defaultLinks = [
    {
      title: locales[window.userLang].terms_conditions,
      link: 'https://everydoggy.com/terms/',
    },
    {
      title: locales[window.userLang].privacy_policy,
      link: 'https://everydoggy.com/policy/',
    },
    {
      title: 'Cancellation Terms',
      link: 'https://everydoggy.com/subscription-terms/#subscription_cancellation',
    },
  ];

  function getPeriod(product) {
    const duration = product.details.duration;

    if (duration) {
      let resultPeriodTextValue = `${duration.value} ${duration.unit}`;
      
      if (resultPeriodTextValue === '1 week') {
        resultPeriodTextValue = `${locales[window.userLang].payment_text_109}`;
      }

      if (resultPeriodTextValue === '1 month') {
        resultPeriodTextValue = `1 ${locales[window.userLang].tariff_month}`;
      }

      if (resultPeriodTextValue === '3 month') {
        resultPeriodTextValue = `3 ${locales[window.userLang].tariff_months}`;
      }

      if (resultPeriodTextValue === '6 month') {
        resultPeriodTextValue = `6 ${locales[window.userLang].tariff_months}`;
      }

      if (resultPeriodTextValue === '1 year') {
        resultPeriodTextValue = `1 ${locales[window.userLang].tariff_year}`;
      }

      

      return resultPeriodTextValue;
    }
  }

  useEffect(() => {
    if(itemRef?.current) {
      if(itemRef.current.querySelector('span')) {
        itemRef.current.querySelector('span').textContent = getPeriod(product);
      }
      if(itemRef.current.querySelector('b')) {
        itemRef.current.querySelector('b').textContent = currency;
      }
      if(itemRef.current.querySelector('i')) {
        itemRef.current.querySelector('i').textContent = price;
      }
    }
  }, [product, price]);

  const linksArr = links || defaultLinks;

  return (
    <>
      <div className={s.warning}>
        <ul className={s.items}>
          <li className={s.item}>{locales[window.userLang].payment_text_48} {getDay(product)}</li>
          <li className={s.item}>
          {locales[window.userLang].payment_text_49}
          </li>
          <li className={s.item} ref={itemRef} dangerouslySetInnerHTML={{ __html: locales[window.userLang].payment_text_50}} />
          <li className={s.item}>{locales[window.userLang].payment_text_51}</li>
        </ul>
      </div>
    </>
  );
};

export default memo(DisclamerNoTrial);
